/**
 * Javascript version of {@link WsAuthenticationType.kt} enum.
 */

export default {
	OAUTH_V2: 'oauth-v2',
	ANONYMOUS: 'anonymous',
	BASIC_HTTP: 'basic-http',
}